import React, { useState } from "react";
import PropTypes from "prop-types";
import { Dropdown, Button } from "semantic-ui-react";

const EnumList = ({ values }) => {
  const [copiedValue, setCopiedValue] = useState("");

  if (!values) return null;

  const handleItemClick = (value) => {
    navigator.clipboard.writeText(value).then(() => {
      setCopiedValue(value);
      setTimeout(() => setCopiedValue(""), 3000); // Clear after 3 seconds
    });
  };

  const options = values.map((v) => ({
    key: v,
    text: v,
    value: v,
    content: (
      <div
        onClick={(e) => {
          e.stopPropagation(); // Prevent dropdown closure
          handleItemClick(v);
        }}
        style={{ cursor: "pointer" }}
      >
        {v}
      </div>
    ),
  }));

  return (
    <div style={{ display: "flex", alignItems: "center", paddingLeft: "1em" }}>
      <Button size="tiny" basic style={{ marginLeft: 6 }}>
        Enum:
      </Button>
      <Dropdown
        placeholder="select to copy"
        selection
        options={options}
        style={{ margin: "6px 0", paddingLeft: "1em", cursor: "pointer" }}
      />
      {copiedValue && (
        <span style={{ fontSize: "0.9em", color: "grey" }}>
          Copied: {copiedValue}
        </span>
      )}
    </div>
  );
};

EnumList.propTypes = { values: PropTypes.array };

export default EnumList;
